<template lang="jade">
  div.Form__wrapper(v-bind:class="{ 'Form__wrapper--collapsed': !show }")
    fieldset.Fieldset(":id"="sectionId")
      template(v-if="fdata.legend")
        include ./_partials/header.jade
      div.Fieldset__body
        partial(name="rawhtml")
</template>

<script>
  import fieldsets from './_shared/traits'

  export default {
    data: () => ({}),
    mixins: [fieldsets],
    partials: {
      rawhtml: ''
    },
    computed: {
      sectionId () {
        let {legend} = this.fdata
        return legend ? 'b-' + legend.replace(/(')/g, '').toLowerCase().split(' ').join('-') : ''
      }
    },
    beforeCompile () {
      let {content} = this.fdata
      let rawHTML = content.reduce((str, n, idx) => {
        if (n.type === 'type_rawHtml') {
          let html = /<\/?[a-z][\s\S]*>/i.test(n.value) ? n.value
                                                     : `<div class="Wrapper">
                                                          <div class="Message Message--info" :skin="skins.messages">
                                                            <i class="fa fa-info" style="margin-right: 15px"></i>
                                                            <span class="Message__body">${n.value}</span>
                                                          </div>
                                                        </div>`
          return str + html
        }
        return str + `<component :is="fdata.content[${idx}].type" :fdata="fdata.content[${idx}]"> </component>`
      }, '')

      this.$options.partials = {rawhtml: rawHTML}
    }
  }
</script>



// WEBPACK FOOTER //
// standard.vue?65e19a73